export const CREATE_IMPORT = 'CREATE_IMPORT'
export const RECEIVE_IMPORT = 'RECEIVE_IMPORT'
export const RECEIVE_ERROR = 'RECEIVE_ERROR'
export const RESET_REQUEST = 'RESET_REQUEST'
